import React from 'react'

const Intro = () => {
    return (
        <div className='h-[calc(100vh-64px)] bg-[#d0c8e6] flex items-center px-4 md:px-9 lg:px-14'>
            <div className="uppercase text-white">
                <h1 className='text-4xl md:text-6xl font-bold mb-4'>new season arrivals</h1>
                <h2 className='text-2xl md:text-4xl font-thin'>check out all the trends</h2>
            </div>
        </div>
    )
}

export default Intro